const addDefaults = (defaults) => (obj) => Object.assign({}, defaults, obj);

export default addDefaults;



// WEBPACK FOOTER //
// ./src/utils/queries/add-defaults.js